interface DataSet {
    isConstant: boolean;
    value: any;
}

export default class Registry {
    protected data: { [key: string] : DataSet; } = {};
	constructor(data: { [key: string] : DataSet; } = {}) {
		this.data = data;
	}

	public get(n: string, def: any): any {
		if(n != null) {
			return (this.data[n]) ? this.data[n].value : def;
		} else {
			return this.toArray(this.data);
		}
	}

	public set(n: string, v: any, isConstant: boolean = false): this {
		if(this.data[n] && this.data[n].isConstant) {
			throw('Cant override constants.');
		}
		this.data[n] = {
			value: v,
			isConstant: (isConstant) ? true : false
		};
		return this;
	}

	public unset(n: string): this {
		if(this.data[n] && !this.data[n].isConstant) {
			delete(this.data[n]);
		}
		return this;
	}

	public toArray(data: any): any {
		let arr: any = {};
        if(data instanceof Array || data instanceof Object) {
            for(const k in this.data) {
                const item = this.data[k];
                arr[k] = this.toArray(item.value);
            }
        } else {
            arr = data;
        }
		return arr;
	}
}
